import dayjs from 'dayjs';

import { convertCo2Score } from '@/data/http/utils/convert-co2-score';
import { CalculateVenueDatesCo2 } from '@/domain/impact-calculate-venue/entities/calculate-venue-co2.entity';
import { formatDateToYearMonth } from '@/domain/utils/format-date-to-year-month';

import { ResultsVenueMonthDto, ResultsVenueScoresObjectDto } from './dto.type';

export class ResultsVenueMonthMapper {
  static dtoToEntity(dto: ResultsVenueMonthDto): CalculateVenueDatesCo2 {
    return {
      score: 0,
      byMonth: convertMonths(dto.months),
      byDate: convertDates(dto.dates),
    };
  }
}

function convertMonths(
  months: Record<string, Record<string, ResultsVenueScoresObjectDto>>,
): Record<
  string,
  {
    score: number;
    env?: {
      score: number;
      maxScore: number;
    };
    totalMen?: number;
    totalWomen?: number;
    totalOther?: number;
  }
> {
  const result: Record<
    string,
    {
      score: number;
      env?: {
        score: number;
        maxScore: number;
      };
      totalMen?: number;
      totalWomen?: number;
      totalOther?: number;
    }
  > = {};
  for (const [yearKey, monthsOfTheYear] of Object.entries(months)) {
    for (const [monthKey, monthScores] of Object.entries(monthsOfTheYear)) {
      const date = dayjs(`${yearKey}-${monthKey}`);
      const formatedDate = formatDateToYearMonth(date.toDate());
      const convertedScore = convertCo2Score(monthScores.co2.score);
      result[formatedDate] = {
        score: convertedScore,
        env: {
          score: monthScores.env?.score,
          maxScore: monthScores.env?.maxScore,
        },
        totalMen: monthScores.ess.stats?.totalMen,
        totalWomen: monthScores.ess.stats?.totalWomen,
        totalOther: monthScores.ess.stats?.totalOther,
      };
    }
  }
  return result;
}

function convertDates(
  dates: Array<{
    id: number;
    results: ResultsVenueScoresObjectDto;
  }>,
): Record<string, { score: number }> {
  const result = dates.reduce<Record<string, { score: number }>>(
    (acc, date) => {
      const convertedScore = convertCo2Score(date.results.co2.score);
      acc[date.id] = { score: convertedScore };
      return acc;
    },
    {},
  );
  return result;
}
